import { useNavigate } from "react-router-dom";
import { IconButton, Box } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ModuleLayout from "./ModuleLayout/ModuleLayout";
import Helpers from "../Config/Helpers";

function Estimates() {
  const navigate = useNavigate();

  const columns = [
    {
      field: "serial",
      headerName: "Sr. #",
      width: 80,
      sortable: false,
      filterable: false,
    },
    {
      field: "customerName",
      headerName: "Customer",
      flex: 1,
      minWidth: 180,
      valueGetter: (_, row) => row.customer?.name || "",
    },
    {
      field: "vehicle",
      headerName: "Vehicle",
      flex: 1,
      minWidth: 180,
      valueGetter: (_, row) =>
        row.vehicle
          ? `${row.vehicle.make || ""} ${row.vehicle.model || ""}`.trim()
          : "",
    },
    {
      field: "totalPrice",
      headerName: "Estimated Amount",
      width: 160,
      renderCell: ({ row }) => `$ ${row.totalPrice ?? 0}`,
    },
  ];

  // Keep the stored backend receipt type as "Quote" for compatibility.
  const searchFilter = (receipt, search) => {
    const isEstimate =
      (receipt.receiptType || receipt.type || "Quote") === "Quote";
    if (!isEstimate) return false;
    if (!search) return true;
    const term = search.toLowerCase();
    return (
      (receipt.customer?.name || "").toLowerCase().includes(term) ||
      `${receipt.vehicle?.make || ""} ${receipt.vehicle?.model || ""}`
        .toLowerCase()
        .includes(term) ||
      String(receipt.totalPrice ?? "").includes(term)
    );
  };

  const sortFunction = () => 0;

  const customActionsRenderer = (
    params,
    canUpdate,
    canDelete,
    _handleEdit,
    handleDelete,
  ) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        gap: 1,
      }}
    >
      <IconButton
        size="small"
        color="warning"
        title="View estimate"
        onClick={() =>
          navigate(`/user/receipts/receipt-details/${params.row._id}`)
        }
      >
        <VisibilityIcon fontSize="small" />
      </IconButton>

      {canUpdate && (
        <IconButton
          size="small"
          color="success"
          title="Edit estimate"
          onClick={() =>
            navigate(`/user/receipts/edit/${params.row._id}`)
          }
        >
          <EditIcon fontSize="small" />
        </IconButton>
      )}

      {canDelete && (
        <IconButton
          size="small"
          color="error"
          title="Delete estimate"
          onClick={() => handleDelete(params.row)}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );

  const getItemName = (receipt) => receipt?.customer?.name || "this estimate";

  return (
    <ModuleLayout
      moduleName="Estimates"
      moduleKey="receipts"
      fetchEndpoint={`receipts/quotes/${Helpers.authParentId}`}
      incrementalPageSize={25}
      icon={require("../images/icons/receipt.png")}
      columns={columns}
      searchFilter={searchFilter}
      sortFunction={sortFunction}
      customActionsRenderer={customActionsRenderer}
      getItemName={getItemName}
      deleteWarning="This action cannot be undone. The estimate will be permanently removed."
      // moduleDescription="Manage and track all customer estimates"
      primaryAction={{
        label: "New RO",
        to: "/user/receipts/add",
      }}
    />
  );
}

export default Estimates;
